<template>
  <pack-lead-widget-table :list="list" :packId="packId"></pack-lead-widget-table>
</template>

<script>
import releaseNoteApi from "@/api/releaseNote";
import PackLeadWidgetTable from "./PackLeadWidgetTable.vue";

export default {
  components: {
    PackLeadWidgetTable,
  },
  computed: {
    packId() {
      return this.$route.params.packId;
    },
  },
  async created() {
    await this.refreshList();
  },
  data() {
    return {
      list: [],
    };
  },
  methods: {
    async refreshList() {
      const qaAnalystFilter = {
        attributeName: "qaAnalyst",
        attributeNameLabel: "QA Analyst",
        dataType: "string",
        operator: "in",
        operatorLabel: "=",
        value: [null],
        valueLabel: "QA Analyst",
        valueType: "array",
      };

      let result;
      try {
        result = await releaseNoteApi.packDashboardWidgetSearch({
          filterList: [qaAnalystFilter],
          packId: this.packId,
        });

        this.list = result;
      } catch (e) {
        console.error(e);
        this.$notifyError("Could not refresh the list of release notes that need a QA Analyst");
      }
    },
  },
  watch: {
    async packId() {
      await this.refreshList();
    },
    list(val) {
      this.$emit("noteCount", val.length);
    },
  },
};
</script>
